import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import "./FeedbackForm.css";
import { FaStar } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  createFeedback,
  fetchFeedbackByDoctorId,
} from "../services/feedbackService";

import Loader from "../../utils/Loader";
const FeedbackForm = ({ doctorId }) => {
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(true);     // Only this line added
  const [showForm, setShowForm] = useState(false);
  const { data } = useSelector((state) => state.login);

  useEffect(() => {
    fetchExistingFeedback();
  }, []);

  const fetchExistingFeedback = async () => {
    try {
      setLoading(true); // Start loading
      const response = await fetchFeedbackByDoctorId(data._id);
      if (response.status === "SUCCESS") {
        setFeedback(response.data);
      }
    } catch (error) {
      console.error("Error fetching existing feedback:", error);
    } finally {
      setLoading(false); // Stop loading - important!
    }
  };

  const formik = useFormik({
    initialValues: {
      comments: feedback?.comments || "",
      rating: feedback?.rating || 0,
      respondentId: data._id,
      userType: "User",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      comments: Yup.string()
        .min(5, "Comment should be at least 5 characters")
        .required("Comment is required"),
      rating: Yup.number()
        .required("Please select a rating")
        .moreThan(0, "Rating must be provided and greater than zero"),
    }),

    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const response = await createFeedback(values);
        if (response.status === "SUCCESS") {
          setFeedback(response.data);
          setShowForm(false);
          resetForm();
        }
      } catch (error) {
        console.error("Error submitting feedback:", error);
      }
      setSubmitting(false);
    },
  });

  // Yeh loader dikhega jab tak feedback check ho raha hai
  if (loading) {
    return (
     <Loader/>
    );
  }

  return (
    <div className="container d-flex justify-content-center align-items-center">
      {feedback && !showForm ? (
        <div className="card p-4 shadow-lg feedback-card w-50">
          <div className="d-flex justify-content-between text-center">
            <label className="form-label text-danger text-center">
              Your submitted response
            </label>
          </div>
          <div className="mb-3">
            <label className="form-label">
              How satisfied are you with the platform?
            </label>
            <div className="star-rating">
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  size={30}
                  className={`star ${
                    star <= feedback.rating ? "selected" : ""
                  }`}
                />
              ))}
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Comments</label>
            <textarea
              name="comments"
              className="form-control"
              value={feedback.comments}
              readOnly
            />
          </div>
          <div className="d-flex justify-content-between">
            <button
              type="button"
              onClick={() => setShowForm(true)}
              className="btn btn-primary filled-btn"
            >
              Edit
            </button>
          </div>
        </div>
      ) : (
        <>
          {!showForm ? (
            <button
              onClick={() => setShowForm(true)}
              className="btn btn-primary btn-lg feedback-button filled-btn"
            >
              Give Feedback
            </button>
          ) : (
            <form
              onSubmit={formik.handleSubmit}
              className="card p-4 shadow-lg feedback-form w-50"
            >
              <div className="mb-3">
                <label className="form-label">
                  How satisfied are you with the platform?
                </label>
                <div className="star-rating">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <FaStar
                      key={star}
                      size={30}
                      className={`star ${
                        star <= formik.values.rating ? "selected" : ""
                      }`}
                      onClick={() => formik.setFieldValue("rating", star)}
                    />
                  ))}
                </div>
                {formik.touched.rating && formik.errors.rating ? (
                  <div className="text-danger">{formik.errors.rating}</div>
                ) : null}
              </div>
              <div className="mb-3">
                <label className="form-label">Comments</label>
                <textarea
                  name="comments"
                  className="form-control"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.comments}
                />
                {formik.touched.comments && formik.errors.comments ? (
                  <div className="text-danger">{formik.errors.comments}</div>
                ) : null}
              </div>
              <div className="d-flex justify-content-between">
                <button
                  type="submit"
                  disabled={formik.isSubmitting}
                  className="btn btn-primary filled-btn"
                >
                  Submit
                </button>
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="btn btn-primary outlined-btn"
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </>
      )}
    </div>
  );
};

export default FeedbackForm;